import { useEffect, useState } from "react";
import AcademyService from "../services/AcademyService";
import { getDocuments } from "../services/DocumentService";

export default function useDocuments(filters) {
  const academyService = new AcademyService();
  const [documents, setDocuments] = useState([]);

  const [loading, setLoading] = useState(false);

  const [meta, setMeta] = useState({});

  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDocuments();
  }, [filters]);

  const fetchDocuments = async () => {
    try {
      setLoading(true);

      const response = await academyService.paymentsDoc(filters);
      /*
            |--------------------------------------------------------------------------
            | IMPORTANTE
            |--------------------------------------------------------------------------
            */

      setDocuments(response.data.data || []);

      setMeta(response.data.meta || []);
    } catch (err) {
      console.error(err);

      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return {
    documents,
    loading,
    meta,
    error,
    refresh: fetchDocuments,
  };
}
